import { Component, ElementRef, EventEmitter, Input, Output, Renderer2 } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomSnackbarService } from '../../custom-notification/custom-notification.component';
import { ServiceListingService } from 'src/app/service/service-listing.service';

@Component({
  selector: 'app-edit-service',
  templateUrl: './edit-service.component.html',
  styleUrls: ['./edit-service.component.css']
})
export class EditServiceComponent {
  form!: FormGroup;

  constructor(private fb: FormBuilder, private serviceListingService: ServiceListingService, 
    private customSnackbarService: CustomSnackbarService, private elementRef : ElementRef, private renderer : Renderer2) { }
  @Input() viewMode: boolean = false;
  @Input() formTitle: string = '';
  @Output() resetListing = new EventEmitter<void>();
  @Output() approve = new EventEmitter();
  @Output() reject = new EventEmitter();
  @Input() selectedId: number = 0;
  @Output() close = new EventEmitter<void>();
  @Output() popUp = new EventEmitter();
  categoryList: any = {
    loading: false,
    response: null,
    error: ''
  };
  subCategoryList: any = {
    loading: false,
    response: null,
    error: ''
  };
  subCategoryVarientList: any = {
    loading: false,
    response: null,
    error: ''
  };
  servTypeList: any = {
    loading: false,
    response: null,
    error: ''
  };
  statusList: any = {
    loading: false,
    response: null,
    error: ''
  };
  serviceDetails: any = {
    loading: false,
    response: null,
    error: ''
  }
  serviceDurationList: any = {
    loading: false,
    response: null,
    error: ''
  };
  appointmentList: any = {
    loading: false,
    response: [
      { id: 'Y', name: 'Yes' },
      { id: 'N', name: 'No' }
    ],
    error: ''
  };
  allowedFileSizeToUpload: number = 2; //size in MB
  uploadingFile: boolean = false;
  submitLoading: boolean = false;
  selectedServiceTypes: any[] = [];
  uploadingMediaIndex: number | null = null;
  approveLoader: boolean = false;
  rejectLoader: boolean = false;
  ngOnInit() {
    this.form = this.fb.group({
      type: "SERVICE",
      id: [null],
      productId: [null],
      businessId: [null],
      productName: ['', [Validators.required, Validators.maxLength(64)]],
      description: ['', Validators.required],
      price: ['', [Validators.required, Validators.min(1)]],
      categoryId: ['', Validators.required],
      subCategoryId: ['', Validators.required],
      discountedPrice: ['', this.discPriceCantMoreThanPrice],
      statusId: ['', Validators.required],
      appointmentFlag: [''],
      requirement: [""],
      mediaList: this.fb.array([this.fb.control("", Validators.required), this.fb.control(""), this.fb.control(""), this.fb.control("")]),
      serviceTypes: ['', Validators.required],
      variantOption1: [''],
    });
    const priceControl = this.form?.get('price');
    if (priceControl) {
      priceControl.valueChanges.subscribe(() => {
        const discountedPriceControl = this.form.get('discountedPrice');
        if (discountedPriceControl) {
          // Clear the value of discountedPrice when price changes
          discountedPriceControl.setValue(discountedPriceControl.value);
          discountedPriceControl.updateValueAndValidity();
        }
      });
    }
    this.getProductCategories()
    this.form.get('categoryId')?.valueChanges.subscribe(newCategoryValue => {
      // Handle changes here
      this.form.get('subCategoryId')?.setValue('')
      this.subCategoryVarientList = {
        loading: false,
        response: null,
        error: ''
      }
      this.getSubCategories(newCategoryValue)
    });

    // this.form.get('serviceTypes')?.valueChanges.subscribe(data => {
    //   console.log(data,'sss')
    //   this.selectedServiceTypes = data.map((l:{id:number,name:string})=>l.name)
    // })

    this.getServiceType()
    this.getProductStatus()
    this.getServiceDurationList()
    if (this.selectedId) {
      this.showDetails(this.selectedId)
    }
  }

  discPriceCantMoreThanPrice(control: any) {
    const value = control.value;
    // Check if the value is greater than 0
    if (value && Number(control?._parent?.value?.price) <= Number(value)) {
      return { moreThanPrice: true };
    }
    return null;
  }
  
  handleProductReject(id: number) {
    if (this.rejectLoader || this.approveLoader) {
      return
    }
    this.rejectLoader = true;
    this.reject.emit(id)
  }
  handleProductApprove(id: number) {
    if (this.rejectLoader || this.approveLoader) {
      return
    }
    this.approveLoader = true;
    this.approve.emit(id)
  }
  // Convenience getters for easy access to form arrays and controls
  get mediaList(): FormArray {
    return this.form.get('mediaList') as FormArray;
  }
  countChars(string:String){
    return string.length
  }
  showDetails(id: number) {
    this.serviceDetails = {
      ...this.serviceDetails,
      loading: true,
      error: ''
    }
    this.serviceListingService.getServiceById(id).then((res: any) => {
      const service = res.data.data;
      this.serviceDetails = {
        ...this.serviceDetails,
        loading: false,
        response: res.data.data,
      }
      this.form.get('id')?.setValue(service.id || '');
      this.form.get('productId')?.setValue(service.id || '');
      this.form.get('businessId')?.setValue(service.businessId || '');
      this.form.get('productName')?.setValue(service.productName || '');
      this.form.get('categoryId')?.setValue(service.categoryId || '');
      this.form.get('subCategoryId')?.setValue(service.subCategoryId || '');
      this.form.get('description')?.setValue(service.description || '');
      this.form.get('price')?.setValue(service.price ? Number(service.price) : '');
      this.form.get('discountedPrice')?.setValue(service.discountedPrice ? Number(service.discountedPrice) : '');
      // this.form.get('appointment')?.setValue(service.appointment || '');
      this.form.get('appointmentFlag')?.setValue(service.appointmentFlag || '');
      this.form.get('statusId')?.setValue(service.statusId || '');
      this.form.get('variantOption1')?.setValue(service.variantOption1 || '');
      this.form.get('requirement')?.setValue(service.requirement || '');
      this.form.get('serviceTypes')?.setValue(service.serviceTypes.length ? service.serviceTypes : '');
      this.selectedServiceTypes = service.serviceTypes;
      if (service.mediaList?.length) {
        service.mediaList.forEach((l: { id: number, src: string }, i: number) => {
          (this.form.get('mediaList') as FormArray).at(i).patchValue(l);
        })
      }

    }).catch((err: any) => {
      this.serviceDetails = {
        ...this.serviceDetails,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }
  selectedServiceTypesToShow(data: any[]) {
    return data.map((l: any) => l.name).join(',')
  }
  comparer(o1: any, o2: any): boolean {
    // if possible compare by object's name, and not by reference.
    return o1 && o2 ? o1.label === o2.label : o2 === o2;
  }
  removeMedia(mediaIndex: number) {
    // this.mediaList.removeAt(index);
    if (mediaIndex >= 0 && mediaIndex <= this.mediaList.length) {
      (this.form.get('mediaList') as FormArray).at(mediaIndex).patchValue("");
    }
  }

  allowOnlyNumeric(event: KeyboardEvent) {
    // Allow backspace
    if (event.key === 'Backspace') {
      return true;
    }

    // Allow only numeric digits
    const isNumeric = /^\d$/.test(event.key);

    if (!isNumeric) {
      event.preventDefault();
      return false;
    }

    return true; // This line is necessary for TypeScript to be satisfied
  }

  getProductCategories() {
    this.categoryList = {
      ...this.categoryList,
      loading: true,
      error: ''
    }
    this.serviceListingService.getProductCategories().then((res: any) => {
      this.categoryList = {
        ...this.categoryList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.categoryList = {
        ...this.categoryList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }
  getProductStatus() {
    this.statusList = {
      ...this.statusList,
      loading: true,
      error: ''
    }
    this.serviceListingService.getProductStatus().then((res: any) => {
      this.statusList = {
        ...this.statusList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.statusList = {
        ...this.statusList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  getServiceDurationList() {
    this.serviceDurationList = {
      ...this.serviceDurationList,
      loading: true,
      error: ''
    }
    this.serviceListingService.getServiceDuration().then((res: any) => {
      this.serviceDurationList = {
        ...this.serviceDurationList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.serviceDurationList = {
        ...this.serviceDurationList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  getSubCategories(catId: string) {
    if (!catId) {
      return
    }
    this.subCategoryList = {
      ...this.subCategoryList,
      response: null,
      loading: true,
      error: ''
    }
    this.serviceListingService.getProductSubCategories(catId).then((res: any) => {
      this.subCategoryList = {
        ...this.subCategoryList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.subCategoryList = {
        ...this.subCategoryList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }
  handleReset(event: any) {
    event.preventDefault()
    // this.form.reset();
    // if (this.selectedId) {
    //   this.showDetails(this.selectedId)
    // }
    this.close.emit()

  }


  getServiceType() {
    this.servTypeList = {
      ...this.servTypeList,
      response: null,
      loading: true,
      error: ''
    }
    this.serviceListingService.getServiceType().then((res: any) => {
      this.servTypeList = {
        ...this.servTypeList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.servTypeList = {
        ...this.servTypeList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }
  get mediaListt() {
    return (this.form.get('mediaList') as FormArray).controls;
  }
  addMediaAtIndex(mediaIndex: number, updatedObject: any) {
    if (mediaIndex >= 0 && mediaIndex <= this.mediaListt.length) {
      (this.form.get('mediaList') as FormArray).at(mediaIndex).patchValue(updatedObject);
    }
  }
  uploadFile(value: any, type: string, index: number) {
    const selectedFile = value.files[0];
    const maxSizeInBytes = this.allowedFileSizeToUpload * 1024 * 1024; // 2MB (adjust to your maximum size)
    if (selectedFile.type === "image/png" || selectedFile.type === "image/jpg" || selectedFile.type === "image/jpeg") {

      if (selectedFile && selectedFile.size > maxSizeInBytes) {
        this.customSnackbarService.openCustomSnackbar(`File size must be less than ${this.allowedFileSizeToUpload} MB`, 30000, true);
        return
      }
      this.uploadingMediaIndex = index;
      this.uploadingFile = true;
      let formData: FormData = new FormData();
      formData.append('files', value.files[0]);
      formData.append('type', 'ProductMedia')

      this.serviceListingService.uploadFile(formData).then((res: any) => {
        if (res.data.status === "SUCCESS") {
          if (type === "media") {
            this.addMediaAtIndex(index, { src: res.data.data.documentUri })
          }
          this.uploadingFile = false;
          this.uploadingMediaIndex = null;
        }
      }).catch((error: any) => {
        this.uploadingMediaIndex = null;
        this.uploadingFile = false;
        this.customSnackbarService.openCustomSnackbar('Something is broken', 3000, true);
      })
    } else {
      this.customSnackbarService.openCustomSnackbar('Only accept .png, .jpg, .jpeg', 30000, true);

    }
  }

  onSubmit() {
    if (this.submitLoading || this.uploadingFile) {
      return
    }

    if (this.form.valid) {
      // Handle form submission logic here
      this.submitLoading = true;
      console.log(this.form.value, 'values')
      this.form.value.mediaList = this.form.value.mediaList.filter((l: any) => l)
      this.serviceListingService.saveProduct(this.form.value).then((res: any) => {
        if (res.data.status === "SUCCESS") {
          this.resetListing.emit()
          this.submitLoading = false;
          this.customSnackbarService.openCustomSnackbar('The service has been updated successfully.', 30000);
        }
      }).catch((error: any) => {
        console.log(error, 'ddd')
        this.submitLoading = false;
        this.customSnackbarService.openCustomSnackbar('Something is broken', 3000, true);
      })
    } else {
      console.log(this.form);
      // Mark all controls as touched to display validation messages
      this.form.markAllAsTouched();
    }
  }

  onPreview(url : string,value : number) : void {
    this.popUp.next({
       url,
       value
    })
  }
}
